module.exports = __webpack_public_path__ + "img/electronic_fence.fdc50471.png";